import React, { Fragment, useState, useEffect } from "react";
import { Tab } from "@headlessui/react";
import DepositDropdown from "../DepositDropdown";
import WithdrawDropdown from "../WithdrawDropdown";
import DepositAddress from "../DepositAddress";
import WithdrawContent from "../WithdrawContent";
import {
  BlockchainName,
  DepositMethods,
  DevType,
  UserBalances,
  UserWallets,
} from "../../typings";
import EventManager from "../../utils/EventManager";

type Args = {
  depositMethods: DepositMethods;
  userWallets: UserWallets;
  generateNewAddress: any;
  userBalances: UserBalances;
  events: EventManager;
  type: DevType;
  closeMainModal: any;
};
export default function ModalTabs({
  depositMethods,
  userWallets,
  generateNewAddress,
  userBalances,
  events,
  type,
  closeMainModal
}: Args) {
  const [selectedBlockchainName, setSelectedBlockchainName] = useState<
    BlockchainName | ""
  >("");
  // const [selectedDepositMethod, setSelectedDepositMethod] = useState<
  //   DepositMethod | ""
  // >("");

  const [depositMessage, setDepositMessage] = useState<string>("");

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }

  let [categories] = useState({
    Deposit: [],
    Withdraw: [],
    // BuyCrypto: [],
    // Tip: [],
  });

  useEffect(() => {
    const depositMethod = depositMethods.find(
      (depositMethod) =>
        depositMethod.blockchain.name === selectedBlockchainName
    );

    if (!depositMethod) return;

    // setSelectedDepositMethod(depositMethod);
    setDepositMessage(depositMethod.messages.deposit);
  }, [selectedBlockchainName]);

  return (
    <Fragment>
      <div className="w-full max-w-md px-2 py-16 sm:px-0">
        <Tab.Group>
          <Tab.List className="flex space-x-1 rounded-xl bg-blue-white/20 p-1 border border-white">
            {Object.keys(categories).map((category) => (
              <Tab
                key={category}
                className={({ selected }) =>
                  classNames(
                    "w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-white",
                    selected
                      ? "bg-white shadow text-blue-700"
                      : "text-white hover:bg-white/[0.12] hover:text-white"
                  )
                }
              >
                {category}
              </Tab>
            ))}
          </Tab.List>
          <Tab.Panels className="mt-4 flex justify-center">
            <Tab.Panel className="w-full">
              <DepositDropdown
                depositMethods={depositMethods}
                onChange={(blockchainName: BlockchainName) => {
                  setSelectedBlockchainName(blockchainName);
                }}
                type={type}
              />
              <DepositAddress
                userWallets={userWallets}
                selectedBlockchainName={selectedBlockchainName}
                generateNewAddress={generateNewAddress}
                depositMethods={depositMethods}
              />

              <div className="mt-6">
                <p className="text-sm text-white">{depositMessage}</p>
              </div>
            </Tab.Panel>
            <Tab.Panel className="w-full">
              <WithdrawDropdown
                depositMethods={depositMethods}
                onChange={(blockchainName: BlockchainName) => {
                  setSelectedBlockchainName(blockchainName);
                }}
                userBalances={userBalances}
                preSelectedblockchainName={selectedBlockchainName}
                type={type}
              />
              <WithdrawContent
                withdrawMethods={depositMethods}
                userBalances={userBalances}
                selectedBlockchainName={selectedBlockchainName}
                events={events}
                closeMainModal={closeMainModal}
              />
              {/* <DepositAddress /> */}
            </Tab.Panel>
            {/* <Tab.Panel className="w-full">
                <ModalDropdown />
                <DepositAddress />
              </Tab.Panel>
              <Tab.Panel className="w-full">
                <ModalDropdown />
                <DepositAddress />
              </Tab.Panel> */}
          </Tab.Panels>
        </Tab.Group>
      </div>
    </Fragment>
  );
}
